import React, { createContext, useContext } from 'react';
import invariant from 'tiny-invariant';
import { DataType } from '@larki/mp/lib/dataType';
import { CartCoverage } from './services/coverage/workers/quote.worker';
import { ShapeDetails } from './lib/shape';
import { PointCloudDataType } from '@larki/mp/lib/dataType';
import { CoverageLabel, Preview } from '@larki/mp/lib/coverage';
import {
  _2dMapCombinedQuote,
  _2dMapQuoteTypes,
} from '@larki/shared/type/order.v2';

export type DataTypeGroup = 'automatic' | 'manual' | 'addOn' | 'customOrder';

export const CartContext = createContext<{
  cartRootRef: React.RefObject<HTMLDivElement | null>;
  isCartLoading: boolean;
  isQuoteLoading: boolean;
  cartItems: ShapeDetails[];
  cartItemsAutomatic: ShapeDetails[];
  cartItemsManual: ShapeDetails[];
  cartItemsAddOn: ShapeDetails[];
  cartItemsCustomOrder: ShapeDetails[];
  isCartEmpty: boolean;
  selectedDataType: DataType | `custom_${string}` | null;
  setSelectedDataType: (dataType: DataType | `custom_${string}` | null) => void;
  // freeUserQuote: _2dMapQuote | null;
  // memberQuote: _2dMapQuote | null;
  // freeUserChargesByDataType: Map<CategoryName, _2dMapQuoteTypes['charge']> | null
  // memberChargesByDataType: Map<CategoryName, _2dMapQuoteTypes['charge']> | null

  cartCoverage: CartCoverage | null;

  canShowSmartSelectionButton: {
    automatic: boolean;
    manual: boolean;
    addOns: {
      bim: boolean;
      '2d': boolean;
    };
  };
  showingAnySmartSelectionButtons: boolean;

  addOnAvailability: {
    bim: boolean;
    '2d': boolean;
  };

  ageLabels: Map<PointCloudDataType, CoverageLabel[]>;

  previews: Map<string, Preview>;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
}>(null!);

export const useCartContext = () => {
  const ctx = useContext(CartContext);
  invariant(ctx, 'CartContext must be used within a CartContext.Provider');
  return ctx;
};
